import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
import { TabPanel, TabView } from 'primereact/tabview';
import { LiquidationDocumentsChecker, CreateContract } from 'features/SubmitProjectProposal/pages';
import { LiquidationCouncil } from 'features/Council/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import { AbilityContext } from 'components/Can';

function SubmitProjectProposalLiquidationPage() {
  const { t } = useTranslation();
  // const { state } = useLocation();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 0;

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <>
          <TabView
            activeIndex={parseInt(tab, 10)}
            onTabChange={(e) => navigate(`.?tab=${e.index}`)}
          >
            <TabPanel header={t('contract.name')} leftIcon="pi pi-list mr-2">
              <CreateContract />
            </TabPanel>
            {ability.can('update', 'summary-report') && (
              <TabPanel
                header={t('projectProposal.viewList.liquidationDocument')}
                leftIcon="pi pi-list mr-2"
              >
                <LiquidationDocumentsChecker />
              </TabPanel>
            )}
            {ability.can('read', 'council') && (
              <TabPanel
                header={t('project.viewList.liquidationCouncil')}
                leftIcon="pi pi-list mr-2"
              >
                <LiquidationCouncil />
              </TabPanel>
            )}
          </TabView>
          <ScrollTop target="parent" />
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default SubmitProjectProposalLiquidationPage;
